import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";

function loadView(view) {
  return () => import(`@/views/${view}.vue`);
}

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: "/vdf", // default: VDF
    },
    {
      path: "/:serviceCode",
      name: "Main",
      component: loadView("Main"),
    },
    {
      path: "/:serviceCode/twc",
      name: "Twc",
      component: loadView("Twc"),
    },
    {
      path: "/book/fail",
      name: "PayFail",
      component: loadView("PayFail"),
      props: {
        page: "PayFail",
        pageName: "결제실패",
      },
    },
    {
      path: "/book/success",
      name: "PaySuccess",
      component: loadView("PaySuccess"),
      props: {
        page: "PaySuccess",
        pageName: "결제성공",
      },
    },

    // FESTA 예약 route
    {
      path: `/:serviceCode/book`,
      component: loadView("SideMenu"),
      props: (route) => {
        let keepComponents = [];
        switch (route.name) {
          case "LineInfo":
          case "Complete":
            keepComponents = [];
            break;
          default:
            keepComponents = ["BookInfo", "Certification", "Clause"];
            break;
        }
        return { keepComponents };
      },
      children: [
        {
          path: "line-info",
          name: "LineInfo",
          component: loadView("LineInfo"),

          props: {
            page: "LineInfo",
            pageName: "노선안내",
          },
        },
        {
          path: "forward",
          name: "Forward",
          component: loadView("BookInfo"),

          props: {
            page: "Forward",
            // pageName: '행사장행 예약하기',
            lineTypeCode: "LRT-FORWAR",
          },
        },
        {
          path: "backward",
          name: "Backward",
          component: loadView("BookInfo"),

          props: {
            page: "Backward",
            // pageName: '귀가행 예약하기',
            lineTypeCode: "LRT-BACKWA",
          },
        },
        {
          path: "clause",
          name: "Clause",
          component: loadView("Clause"),

          props: {
            page: "Clause",
            pageName: "면책사항 동의",
          },
        },
        {
          path: "certification",
          name: "Certification",
          component: loadView("Certification"),

          props: {
            page: "Certification",
            pageName: "인증하기",
          },
        },
        {
          path: "pay",
          name: "Pay",
          component: loadView("Pay"),

          props: {
            page: "Pay",
            pageName: "결제하기",
          },
          meta: { requiresAuth: true },
        },
        {
          path: "complete",
          name: "Complete",
          component: loadView("Complete"),

          props: {
            page: "Complete",
            pageName: "예약완료",
          },
        },
      ],
    },

    // 기타노선예약 route
    {
      path: `/:serviceCode/etc-book`,
      component: loadView("SideMenu"),
      props: (route) => {
        let keepComponents = [];
        switch (route.name) {
          case "Complete":
            keepComponents = [];
            break;
          default:
            keepComponents = ["BookInfo", "Certification", "Clause"];
            break;
        }
        return { keepComponents };
      },
      children: [
        {
          path: "certification",
          name: "EtcCertification",
          component: loadView("Certification"),

          props: {
            page: "EtcCertification",
            pageName: "기본 정보 입력",
          },
        },
        {
          path: "forward",
          name: "EtcForward",
          component: loadView("BookInfo"),

          props: {
            page: "EtcForward",
            lineTypeCode: "LRT-FORWAR",
          },
        },
        {
          path: "backward",
          name: "EtcBackward",
          component: loadView("BookInfo"),

          props: {
            page: "EtcBackward",
            lineTypeCode: "LRT-BACKWA",
          },
        },
        {
          path: "clause",
          name: "EtcClause",
          component: loadView("Clause"),

          props: {
            page: "EtcClause",
            pageName: "여행자 보험 신청",
          },
        },
        {
          path: "pay",
          name: "EtcPay",
          component: loadView("Pay"),

          props: {
            page: "EtcPay",
            pageName: "신청내역 확인하기",
          },
          meta: { requiresAuth: true },
        },
        {
          path: "complete",
          name: "EtcComplete",
          component: loadView("Complete"),

          props: {
            page: "EtcComplete",
            pageName: "신청완료",
          },
        },
      ],
    },

    {
      path: `/:serviceCode/question`,
      component: loadView("SideMenu"),
      children: [
        {
          path: "faq",
          name: "FAQ",
          component: loadView("FAQ"),

          props: {
            page: "FAQ",
            pageName: "자주하는 질문",
          },
        },
      ],
    },
    {
      path: `/:serviceCode/check`,
      component: loadView("SideMenu"),
      children: [
        {
          path: "book-confirm",
          name: "BookConfirm",
          component: loadView("CheckCertification"),

          props: {
            page: "BookConfirm",
            pageName: "예약확인하기",
          },
        },
        {
          path: "book-cancel",
          name: "BookCancel",
          component: loadView("CheckCertification"),

          props: {
            page: "BookCancel",
            pageName: "예약취소하기",
          },
        },
        {
          path: "book-list",
          name: "BookList",
          component: loadView("BookDetail"),

          props: {
            page: "BookList",
            pageName: "예약 내역",
          },
          meta: { requiresAuth: true },
        },
      ],
    },
    // 404 페이지 메인화면으로 이동
    // {
    // 	path: '/:pathMatch(.*)*',
    // 	redirect: '/',
    // },
  ],
});

router.beforeEach((to, from) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const accessToken = store.state.member.accessToken;
    if (accessToken) {
      return;
    } else {
      return { name: "Main", params: to.params };
    }
  } else if (from.path === "/") {
    // FESTA 새로고침
    switch (to.name) {
      case "Forward":
      case "Backward":
      case "Clause":
      case "Certification":
      case "Pay":
      case "EtcCertification":
      case "EtcForward":
      case "EtcBackward":
      case "EtcClause":
      case "EtcPay":
        return { name: "Main", params: to.params };
      default:
        return;
    }
  } else {
    return;
  }
});

export default router;
